/* eslint-disable import/prefer-default-export */
export const enrollmentSituation = {
  ENROLLED: "Cursando",
  LOCKED: "Trancado",
  COMPLETED: "Concluído",
};